import dayjs from 'dayjs';
import { get } from 'lodash';

export type FilterValueType = string | string[] | boolean | undefined;

export type FiltersType = {
  [key: string]: FilterValueType;
};

export type DataFiltersType<T> = {
  filters?: FiltersType;
  searchBy?: Record<string, string[]>;
};

type FilterDataProps<T> = {
  data: T[];
} & DataFiltersType<T>;

export function filterData<T>({
  data,
  filters,
  searchBy,
}: FilterDataProps<T>): T[] {
  if (!Array.isArray(data)) return [];
  if (!filters) return data;

  return data.filter((item) => {
    const matches: boolean[] = [];

    for (const key in filters) {
      const filterValue = filters[key];
      if (
        filterValue === undefined ||
        filterValue === null ||
        filterValue === ''
      )
        continue;

      if (key === 'sort' || key === 'sort_by') continue;

      // 🔹 Если этот фильтр имеет множественные поля в searchBy
      if (searchBy && get(searchBy, key)) {
        // if (searchBy && searchBy[key]) {
        const searchValue = String(filterValue).toLowerCase();
        const fields = get(searchBy, key);
        // const fields = searchBy[key];

        const found = fields.some((field) => {
          const itemValue = String((item as any)[field] ?? '').toLowerCase();
          return itemValue.includes(searchValue);
        });

        matches.push(found);
        continue;
      }

      // 🔹 Диапазонные фильтры (_from / _till)
      if (key.endsWith('_from') || key.endsWith('_till')) {
        const baseKey = key.replace(/_(from|till)$/, '');
        const raw = (item as any)[baseKey];

        // if (raw === undefined || raw === null) continue;
        if (raw === undefined || raw === null) {
          matches.push(false);
          continue;
        }

        const itemValue = parseComparableValue(raw);
        const compareValue = parseComparableValue(filterValue);

        if (key.endsWith('_from')) {
          matches.push(itemValue >= compareValue);
        } else {
          matches.push(itemValue <= compareValue);
        }
        continue;
      }

      // 🔹 Обычные строковые фильтры
      const raw = (item as any)[key];
      if (raw === undefined || raw === null) continue;

      const itemValue = String(raw).toLowerCase();
      const filterValues = Array.isArray(filterValue)
        ? filterValue.map((v) => String(v).toLowerCase())
        : [String(filterValue).toLowerCase()];

      matches.push(filterValues.some((val) => itemValue.includes(val)));
    }

    return matches.every(Boolean);
  });
}

/**
 * Универсальное приведение значения к числу или timestamp
 */
export function parseComparableValue(value: any): number {
  if (dayjs(value).isValid()) {
    return dayjs(value).valueOf();
  }

  const num = Number(value);
  if (!isNaN(num)) return num;

  return String(value).charCodeAt(0);
}
